<script>
  export let checked = false
  export let label = ''
  export let error = false
  export let style
</script>

<style>
  :global(._19vn1) {
    margin-bottom: 8px;
  }

  :global(.UcEzx) {
    width: 100%;
    margin: -3px 0 5px 1px;
    color: #dc3545;
    font-size: 14px;
  }

  label {
    font-size: 14px;
  }
</style>

<div class="_19vn1">
  <label {style}>
    <input type="checkbox" bind:checked />
    {label}
  </label>
</div>
{#if error}
  <div class="UcEzx">{error}</div>
{/if}
